import { useState } from "react"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { login } from "~/api/auth"
import { PageShell } from "~/components/PageShell"
import { clearLoginReturnPath, getLoginReturnPath } from "~/utils/loginReturnPath"

export function LoginPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    if (!email.trim() || !password) return
    try {
      await login(email.trim(), password)
      const returnPath = getLoginReturnPath(searchParams)
      clearLoginReturnPath()
      navigate(returnPath, { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : "Log in failed")
    }
  }

  return (
    <PageShell innerClassName="max-w-lg w-full">
      <section className="w-full rounded-lg bg-[var(--color-surface-card)] p-6 shadow-sm">
        <h1 className="text-2xl font-semibold text-[var(--color-text-primary)]">
          Log in
        </h1>
        <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
          <label htmlFor="login-email" className="block text-sm font-medium text-[var(--color-text-primary)]">
            Email
          </label>
          <input
            id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="rounded-lg border border-[var(--color-divider)] bg-[var(--color-bg-primary)] px-4 py-3 text-[var(--color-text-primary)] focus:border-[var(--color-divider)] focus:outline-none focus:ring-1 focus:ring-[var(--color-divider)]"
          />
          <label htmlFor="login-password" className="block text-sm font-medium text-[var(--color-text-primary)]">
            Password
          </label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="rounded-lg border border-[var(--color-divider)] bg-[var(--color-bg-primary)] px-4 py-3 text-[var(--color-text-primary)] focus:border-[var(--color-divider)] focus:outline-none focus:ring-1 focus:ring-[var(--color-divider)]"
          />
          <p className="-mt-2 text-right text-sm">
            <Link to="/forgot-password" className="text-[var(--color-text-primary)] underline">
              Forgot password?
            </Link>
          </p>
          {error && (
            <p className="text-sm text-red-600" role="alert">
              {error}
            </p>
          )}
          <button
            type="submit"
            className="rounded-lg bg-[var(--color-text-primary)] px-6 py-3 font-medium text-[var(--color-surface-card)] transition hover:opacity-90"
          >
            Log in
          </button>
        </form>
      </section>
      <p className="text-center text-sm text-[var(--color-text-secondary)]">
        Don&apos;t have an account?{" "}
        <Link to="/signup" className="text-[var(--color-text-primary)] underline">
          Sign up
        </Link>
      </p>
    </PageShell>
  )
}
